// Copyright (c) 2016 Deere & Company

import ClaimDetailsContainer from './claim-details-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.pip.claim,
    formValidation: state.claims.pip.formValidation,
    isEditable: state.claims.pip.isEditable,
    isNonTracked: state.claims.pip.isNonTracked,
    isValidClaim: state.claims.pip.isValidClaim,
    ownershipStatus: state.claims.ownershipStatus,
    pipDetails: state.claims.pip.pipDetails,
    pipProducts: state.claims.pip.pipProducts,
    product: state.claims.pip.product,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimDetailsContainer);



// WEBPACK FOOTER //
// ./src/claim/pip/components/claim-details-section/index.js